export interface GetEscalationListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetEscalationListPagingAndFilterResponseData
}

export interface GetEscalationListPagingAndFilterResponseData {
    items: GetEscalationListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetEscalationListPagingAndFilterResponseItem {
    escalationId: string
    period?: number
    periodStr?: string
    transactionDate?: string
    transactionDateStr?: string
    description?: string
    totalValue?: number
    /** Maliyet kalemi satırları. Listede her biri ayrı kolon olur. */
    items: GetEscalationItemResponseItem[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetEscalationItemResponseItem {
    escalationItemId: string
    costItemId?: string
    costItemName?: string
    value?: number
    description?: string
}

export const initialGetEscalationListPagingAndFilterResponseData: GetEscalationListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}

export interface GetEscalationByIdResponse {
    isSuccess: boolean
    message: any
    data: GetEscalationListPagingAndFilterResponseItem
}

export interface AddEscalationResponse {
    isSuccess: boolean
    message: any
    data: GetEscalationListPagingAndFilterResponseItem
}

export interface DeleteEscalationResponse {
    isSuccess: boolean
    message: any
    data: number
}

export interface ExportEscalationListResponse {
    isSuccess: boolean
    message: any
    data: string
}

/** Listedeki dinamik kolonlar: kullanılmış maliyet kalemleri. */
export interface EscalationCostItemColumn {
    costItemId: string
    name: string
}

export interface GetEscalationCostItemColumnsResponse {
    isSuccess: boolean
    message: any
    data: EscalationCostItemColumn[]
}
